<mat-tab-group color="primary">
  <mat-tab label="Planning Content">
    <app-rich-text-editor [formControl]="textControl"></app-rich-text-editor>
  </mat-tab>
</mat-tab-group>
